<div class="mobile-po-right">
  <div class="modal-top"></div>
  <div class="ion-no-border">
    <ion-toolbar class="toolbar-label">
      <ion-buttons slot="start">
        <ion-button data-cy="navigate-back-button" (click)="goBack()">
          <ion-icon name="chevron-back" color="dark"></ion-icon>
        </ion-button>
      </ion-buttons>
      <h2 data-cy="po-popover-mobile-title-label" class="popup-title">
        {{ title }}
      </h2>
      <ion-buttons slot="end"> </ion-buttons>
    </ion-toolbar>
  </div>
  <app-change-po
    (titleIdentified)="onTitleIdentified($event)"
    (poUpdated)="onPoUpdate()"
  ></app-change-po>
</div>
